// 导入封装好的 axios 实例
import request from '@/utils/request'


//mqtt列表接口
export function mqttList(data) {
    return request({
        url: '/bot/mqtt/status/page',
        method: 'post',
        data
    })
}

//服务器列表
export function serverList(data) {
    return request({
        url: '/bot/mqtt/server/config/page',
        method: 'post',
        data
    })
}

//新增mqtt订阅
export function mqttStatus(data) {
    return request({
        url: '/bot/mqtt/status',
        method: 'post',
        data
    })
}

//删除mqtt消息
export function delmqtt(id) {
    return request({
        url: `/bot/mqtt/status/${id}`,
        method: 'delete',
    })
}

// 查询最近一个月的数据
export function getSensorDataForMonth(params) {
    return request.get('/bot/mqtt/sensor/data/month', {params})
}
